import { Clock, ShieldCheck, MapPin, DollarSign, Package, Headphones, Globe, Users, Trophy, Ban, AlertTriangle, FileText } from 'lucide-react';
import { Feature, Step, Partner, Testimonial } from './types';

export const NAV_LINKS = [
  { name: 'Home', href: '/home' },
  { name: 'How It Works', href: '/home/how-it-works' },
  { name: 'Services', href: '/home/services' },
  { name: 'Pricing', href: '/home/pricing' },
  { name: 'FAQ', href: '/home/faq' },
  { name: 'Contact', href: '/home/contact' },
];

export const CONTACT_INFO = {
  email: 'info@otlcolombo.com',
  phoneSriLanka: '+94 777 846 800',
  phoneMaldives: '+960 910 0173',
  address: 'No 13 Lauries Road, Colombo 04, Sri Lanka',
};

export const STATS = [
  { label: 'Packages Shipped', value: '50k+', icon: Package },
  { label: 'Members Worldwide', value: '1,000+', icon: Users },
  { label: 'Countries Served', value: '2', icon: Globe }, // Specific to OTL
  { label: 'Years in Service', value: '5+', icon: Trophy },
];

export const FEATURES: Feature[] = [
  {
    id: 1,
    title: 'Fast & Reliable Delivery',
    description: 'Express shipping from Colombo to Male within 3-5 days.',
    icon: Clock,
  },
  {
    id: 2,
    title: 'Secure Free Storage',
    description: 'Shop multiple stores and store items for free for 30 days.',
    icon: ShieldCheck,
  },
  {
    id: 3,
    title: 'Package Consolidation',
    description: 'Combine multiple boxes into one to save up to 80% on shipping.',
    icon: Package,
  },
  {
    id: 4,
    title: 'No Hidden Fees',
    description: 'Transparent pricing with tax-free shopping options.',
    icon: DollarSign,
  },
];

export const STEPS: Step[] = [
  {
    id: 1,
    title: 'Join OTL to get your Sri Lankan address',
    description: 'Sign up for free and instantly receive your personal suite address in Colombo.',
    image: 'https://otl.nyc3.cdn.digitaloceanspaces.com/otlexp.com%20-%20FE/Step%201.jpg',
  },
  {
    id: 2,
    title: 'Shop Sri Lankan stores, ship to your OTL address',
    description: 'Buy from Odel, Kelly Felder, and more. Enter your OTL address at checkout.',
    image: 'https://otl.nyc3.cdn.digitaloceanspaces.com/otlexp.com%20-%20FE/Step%203.jpg',
  },
  {
    id: 3,
    title: 'Combine packages and save on shipping',
    description: 'We receive your goods, consolidate them into one shipment, and forward them to you.',
    image: 'https://otl.nyc3.cdn.digitaloceanspaces.com/otlexp.com%20-%20FE/Step%204.jpg',
  },
];

export const PARTNERS: Partner[] = [
  { id: 1, name: 'Dilly & Carlo', logo: 'https://www.dillyandcarlo.com/cdn/shop/files/Dilly-Logo_1c8935f7-74a6-4959-aadd-86348a2b3f90.jpg?v=1712143108', url: 'https://www.dillyandcarlo.com/' },
  { id: 2, name: 'Moose Clothing Company', logo: 'https://i0.wp.com/eyeviewsl.com/wp-content/uploads/2023/10/Moose-logo.jpeg?resize=350%2C200&ssl=1', url: 'https://mooseclothingcompany.com/' },
  { id: 3, name: 'Emerald', logo: 'https://emerald.lk/cdn/shop/files/emerald-emblem-black-logo_5x_826cb372-18db-4037-a99b-fdb34c9cff35.png?v=1732276589&width=200', url: 'https://emerald.lk/' },
  { id: 4, name: 'G Flock', logo: 'https://gflock.lk/cdn/shop/files/com_logo_280x@2x.jpg?v=1641963657', url: 'https://gflock.lk/' },
  { id: 5, name: 'Kelly Felder', logo: 'https://kellyfelder.com/cdn/shop/files/KF_LOGO_BLACK.png?v=1744744191&width=300', url: 'https://kellyfelder.com/' },
  { id: 6, name: 'Fashion Bug', logo: 'https://fashionbug.lk/cdn/shop/files/FASHION_BUG_MAIN_LOGO.png?v=1754913436&width=300', url: 'https://fashionbug.lk/' },
  { id: 7, name: 'Amanté', logo: 'https://amante.lk/cdn/shop/files/logo1_140x_9c92e7ca-6b82-4627-b1b3-e18d5c4e707a_140x.png?v=1613552750', url: 'https://amante.lk/' },
  { id: 8, name: 'Carnage', logo: 'https://incarnage.com/cdn/shop/files/WhatsApp_Image_2024-10-11_at_13.19.37_500x.jpg?v=1728642862', url: 'https://incarnage.com/' },
  { id: 9, name: 'Midnightdivas', logo: 'https://midnightdivas.com/cdn/shop/files/md-logo-web_1_c65cabd5-cbd8-437e-9e5c-2b4ef3ce38a8.png?v=1735787831', url: 'https://midnightdivas.com/' },
];

export const WHY_CHOOSE_US_POINTS = [
  { text: '30 Days Free Storage', icon: Package },
  { text: 'Save up to 80% with Consolidation', icon: DollarSign },
  { text: 'Dedicated Support for Maldivians', icon: Headphones },
  { text: 'Real-Time Tracking System', icon: MapPin },
  { text: 'Safe & Secure Handling', icon: ShieldCheck },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 1,
    name: 'Aishath R.',
    location: 'Male, Maldives',
    text: "I used to wait weeks for friends to bring my clothes from Sri Lanka. OTL Express is a game changer! Got my G-Flock dress in 4 days.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mohamed N.',
    location: 'Hulhumale, Maldives',
    text: "The consolidation service saved me so much money. I bought car parts from 3 different shops and paid for shipping only once.",
    rating: 5,
  },
  {
    id: 3,
    name: 'Fathimath Z.',
    location: 'Addu City, Maldives',
    text: "Super reliable and professional. The customer support team actually answers the phone!",
    rating: 5,
  },
];

export const FAQs = [
  {
    category: "Shipping",
    items: [
      { question: "How long does shipping take to Maldives?", answer: "Typically, express shipping takes 3-5 business days from our Colombo warehouse to Male." },
      { question: "Do you deliver to islands outside Male?", answer: "Yes, we facilitate delivery to other islands through local Maldivian courier partners." },
    ]
  },
  {
    category: "Storage",
    items: [
      { question: "Is storage really free?", answer: "Yes, we offer 30 days of free storage so you can wait for multiple packages to arrive before shipping." },
      { question: "What happens after 30 days?", answer: "After 30 days, a small daily storage fee applies per package." },
    ]
  },
];

export const RULES = [
  {
    title: "Prohibited Items",
    icon: Ban,
    items: ["Explosives & Flammables", "Narcotics & Illegal Drugs", "Weapons & Firearms", "Perishable Foods (without prior approval)"]
  },
  {
    title: "Restricted Items",
    icon: AlertTriangle,
    items: ["Batteries (Lithium Ion)", "Perfumes (Requires special handling)", "Liquids > 100ml"]
  },
  {
    title: "Customs & Duties",
    icon: FileText,
    items: ["Customers are responsible for Maldivian customs duties.", "Personal items under a certain value may be exempt.", "We assist with documentation."]
  }
];